import { useMemo } from 'react';
import { Autocomplete, FormControl, FormHelperText, TextField, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useAdminModelsQuery } from '../../../api/gql';
import { useErrorMessageResolver } from '../../../localization/useErrorMessageResolver';

type ModelsFormAutocompleteProps = {
  control: Control<any>;
  name: string;
  label: string;
  readonly?: boolean;
};

export const ModelsFormAutocomplete = (props: ModelsFormAutocompleteProps) => {
  const { data, isLoading, isError } = useAdminModelsQuery();
  const resolveErrorMessage = useErrorMessageResolver();

  const options = useMemo(
    () =>
      data?.invoiceModels.map((model) => ({
        id: model.id,
        label: model.name,
      })),
    [data],
  );

  if (isError) {
    return <Typography>Data o modelech se nepodařio načíst</Typography>;
  }

  return (
    <Controller
      control={props.control}
      render={({ field, fieldState }) => (
        <FormControl fullWidth error={!!fieldState.error}>
          <Autocomplete
            loading={isLoading}
            {...field}
            readOnly={props.readonly}
            onChange={(e, v) => field.onChange(v?.id ?? '')}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.label}
                error={!!fieldState.error}
                variant={props.readonly ? 'standard' : 'outlined'}
                InputProps={{
                  ...params.InputProps,
                  readOnly: props.readonly,
                  disableUnderline: props.readonly,
                }}
              />
            )}
            options={options ?? []}
            isOptionEqualToValue={(option, value) => (value.id ? option.id === value.id : option.id === value)}
          />
          {fieldState.error?.message ? (
            <FormHelperText>{resolveErrorMessage(fieldState.error.message)}</FormHelperText>
          ) : null}
        </FormControl>
      )}
      name={props.name}
    />
  );
};
